import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PacmanWrapper from "../../components/dashboard/PacmanWrapper";
import core from "../../vendors/core-api";
import NotFound from "./NotFoundPageEvent";

const EventLink = () => {
  const [redirect, setRedirect] = useState(false);
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { eventId } = useParams();

  useEffect(() => {
    const fetchEventData = async () => {
      const api = core("pu").get();

      try {
        setLoading(true);
        const response = await api.get(
          `/branded-website/reservation/event/${eventId}`,
        );

        if (response.status >= 400) {
          throw new Error("Event not found");
        }
        setEventData(response.data);

        // Check if url exists and redirect accordingly
        if (response.data.url) {
          setRedirect(response.data.url);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (eventId) {
      fetchEventData();
    }
  }, [eventId]);

  if (loading) {
    return <PacmanWrapper />;
  }

  if (error) {
    return <NotFound />;
  }

  if (redirect && eventData) {
    window.location.assign(redirect);
    return null;
  }

  return <PacmanWrapper />;
};

export default EventLink;
